import React from 'react';
import Link, { navigateTo } from 'gatsby-link';
import Content, { HTMLContent } from '../components/Content';
import Logo from '../components/logo/Logo'
import Services from '../components/Services'
import ServiceDetails from '../components/ServiceDetails'
import AboutDetails from '../components/AboutDetails'
import Projects from '../components/Projects'
import ParagraphSection from '../components/ParagraphSection'
import ScrollComponent from '../components/ScrollComponent'
import StatsTable from '../components/StatsTable'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
//import 'react-vertical-timeline-component/style.min.css';

const Icon = ({ type }) => (
  <i className={type || 'fa fa-briefcase'} aria-hidden="true" />
);

const headerFadeOffset = 0.03;
const featuredProjectsLimit = 3;

export class HomePageTemplate extends ScrollComponent {
  constructor() {
    super();
    this.state = { headerOpacity: 1, canPerfWar: false };
  }

  onScroll(event, top) {
    if (!this.el) {
      return;
    }

    let opacity = 1 - (top / this.el.clientHeight);

    if (opacity >= 0 && opacity <= 1) {
      if (opacity < 1) {
        opacity = opacity - headerFadeOffset;
      }

      this.setState({ headerOpacity: opacity });
    }
  }

  onPerfKeyPress(event) {
    if (event.key == 'Enter') {
      this.doWar();
    }
  }

  onPerfTextChange(event) {
    const canPerfWar = Boolean(event && event.target && event.target.value);
    const perfWarUrl = canPerfWar ? event.target.value : null;

    this.setState({ canPerfWar, perfWarUrl });
  }

  doWar() {
    if (this.state.perfWarUrl) {
      navigateTo('/performance?fight=' + this.state.perfWarUrl);
    }
  }

  render() {
    const props = this.props;

    return <section className="section home-page">
      <header className="home" style={{ backgroundImage: `url(${props.image})`, opacity: this.state.headerOpacity }} ref={node => this.el = node}>
        <div className="container animate fade-in animate-delay-0x">
          <div className="row">
            <div className="col-md-10 col-lg-8 col-xl-6">
              <Logo size="xl" />
              <Services services={props.services} />

              <h5>{props.title}</h5>
              <p className="main">
                {props.description}
              </p>

              <Link className="btn btn-outline-primary btn-lg jumbo-btn" to="/contact">
                <i className="fa fa-handshake-o" aria-hidden="true"></i> {props.contact.text}
                <i className="catchphrase">
                  <strong> let's work together to build something great!</strong>
                </i>
              </Link>
            </div>
          </div>
        </div>
      </header>

      <section className="container text-center home-section">
        <h1 className="header-hero animate animate-delay-1x fade-in">{props.heading}</h1>
      </section>

      <section className="home-section container animate animate-delay-2x fade-in">
        <div className="row">
          <div className="col-md-3 d-none d-md-block">
            <i className={'home-design ' + props.performance.side_icon} aria-hidden="true"></i>
          </div>
          <div className="col-sm-12 col-md-9 fadebg-left">
            <h1>
              <i className={props.performance.heading_icon} aria-hidden="true"></i>&nbsp;
              {props.performance.heading}
            </h1>

            <ParagraphSection paragraphs={props.performance.blurbs} />

            <h5>{props.performance.stats_heading}:</h5>
            <StatsTable stats={props.performance.stats} />

            <h1>
              <i className={props.performance.heading2_icon} aria-hidden="true"></i>&nbsp;
              {props.performance.heading2}
            </h1>

            <ParagraphSection paragraphs={props.performance.blurbs2} />
          </div>
        </div>

        <hr />
        <div className="text-center">
          <h1>Still not convinced I can build you a better website?
            <br /> <small>Compare <u>your</u> current site against <u>mine</u>:</small></h1>

          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-8 col-lg-6 col-sm-4">
              <div className="input-group">
                <input type="text" onChange={this.onPerfTextChange.bind(this)} onKeyPress={this.onPerfKeyPress.bind(this)} className="form-control" placeholder="Enter your current site URL" aria-label="Current website URL" />
                <span className="input-group-btn">
                  <button onClick={this.doWar.bind(this)} className="btn btn-secondary" type="button" disabled={this.state.canPerfWar ? '' : 'disabled'}>
                    <i className="fa fa-tachometer" aria-hidden="true"></i> Compare
                  </button>
                </span>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </section>

      <section className="home-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-9">
              <h1 className="fancy">{props.servicesHeading}</h1>
              <ServiceDetails services={props.services} />
            </div>
            <div className="text-right col-md-3 d-none d-md-block">
              <i className="fa fa-laptop home-skills" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </section>

      <section className="home-section brick">
        <div className="container">
          <div className="row">
            <div className="col-sm-2 d-none d-sm-block">
              <i className="fa fa-user-circle home-about" aria-hidden="true"></i>
            </div>
            <div className="col-xs-12 col-sm-10 home-fadebg">
              <h1 className="fancy">{props.aboutHeading}</h1>
              <AboutDetails details={props.about} />
            </div>
          </div>
        </div>
      </section>

      <section className="timeline">
        <div className="container cushy-top">
          <h1 className="text-center">Work experience & education</h1>
          <VerticalTimeline>
            {props.timeline.map((item) => {
              return <VerticalTimelineElement key={item.title}
                className="vertical-timeline-element--work"
                date={item.from + ' to ' + (item.to ? item.to : ' present') + ' (' + ((item.to || new Date().getFullYear()) - item.from) + ' years)'}
                iconStyle={{ background: item.color || 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<Icon type={item.icon}
                  style={{ 'border-top': item.color || 'rgb(33, 150, 243)' }} />}>
                <h3 className="vertical-timeline-element-title">{item.title}</h3>
                <h5 className="vertical-timeline-element-subtitle">
                  <a href={item.link} target="_blank" style={{ color: item.color }}>
                    {item.company}
                  </a>
                </h5>
                <p>
                  {item.description}
                </p>
              </VerticalTimelineElement>
            })}
          </VerticalTimeline>
        </div>
      </section>

      <div className="text-center cushy-bottom">
        <h5 className="resume-heading">Checkout my resume for additional details:</h5>
        <Link className="btn btn-lg btn-info" to="/resume">
          <i className="fa fa-file-text-o"></i> View Resume
        </Link>
      </div>

      <section className="container text-center">
        <hr />
        <h1 className="fancy cushy-bottom cushy-top">Recent Projects:</h1>

        <Projects projects={props.recentProjects} limit={featuredProjectsLimit} />
      </section>

      <div className="text-center cushy-top">
        <Link to="/portfolio" className="btn btn-lg btn-outline-secondary">
          <i className="fa fa-folder-open-o" aria-hidden="true"></i> View {props.recentProjects.length - featuredProjectsLimit} More Projects
        </Link>
      </div>
    </section>;
  }
}

export default ({ data }) => {
  const { frontmatter } = data.markdownRemark;
  const { edges: projects } = data.allMarkdownRemark;
  return <HomePageTemplate
    image={frontmatter.image}
    title={frontmatter.title}
    heading={frontmatter.heading}
    description={frontmatter.description}
    servicesHeading={frontmatter.services_heading}
    services={frontmatter.services}
    contact={frontmatter.contact}
    performance={frontmatter.performance}
    aboutHeading={frontmatter.about_heading}
    about={frontmatter.about}
    timeline={frontmatter.timeline}
    recentProjects={projects.filter(post => post.node.frontmatter.templateKey === 'portfolio-post')}
  />;
};

export const pageQuery = graphql`
  query HomePage($path: String!) {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          frontmatter {
            title
            description
            thumbnail
            templateKey
            date(formatString: "MMMM DD, YYYY")
            featured
            path
          }
        }
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      frontmatter {
        path
        image
        title
        heading
        description
        contact {
          text
          email
          phone
        }
        services_heading
        services {
          icon
          text
          full_text
          description
          secondary
          items
        }
        performance {
          heading
          heading_icon
          heading2
          heading2_icon
          side_icon
          blurbs {
            heading
            text
          }
          stats_heading
          stats {
            label
            mine
            theirs
          }
          blurbs2 {
            heading
            text
          }
        }
        about_heading
        about {
          icon
          text
          description
          traits
          dev
          platforms
          education {
            degree
            title
            school
            link
            items
          }
        }
        timeline {
          title
          company
          from
          to
          link
          icon
          color
          description
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/index.js